import {JSX} from "react";

import "@/entities/destination/attraction/ui/schedule-prices/styles/schedule-prices.scss";

export interface SchedulePricesProps {
    html: string;
    className?: string;
}

/**
 * Component for rendering Schedule & Prices HTML content
 * Specialized for pricing lists and schedule information
 */
export function SchedulePrices({html, className = ""}: SchedulePricesProps): JSX.Element {
    return <div className={`schedule-prices ${className}`} dangerouslySetInnerHTML={{__html: html}} />;
}
